import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ICreateDocumentTemplateExecutorProps } from './ICreateDocumentTemplateExecutorProps';
import { CreateDocumentTemplateExecutorModal } from './CreateDocumentTemplateExecutorModal';

export const CreateDocumentTemplateExecutor = createDocModalExecutor<ICreateDocumentTemplateExecutorProps>({
    modal: CreateDocumentTemplateExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
